export const formattedDate = (date, locale) =>
  new Date(date).toLocaleDateString(locale, { year: 'numeric', month: 'short', day: 'numeric' });

export const formattedTime = (time, locale) =>
  new Date(time).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
